module.exports = __webpack_public_path__ + "static/cookie2-bf62704ee5e79246e71a0793e1aeae98.png";